import { Col, Collapse, Input, Row, Select } from "antd";
import React from "react";
import {
	RICHMENU_ACTION_PLACEHOLDER,
	RICHMENU_ACTION_VALUE_MAP,
	RICHMENU_INPUT_OPTIONS,
} from "../../constants/richmenu.constants";
import type { RichMenuData } from "../../types/richmenu.types";

interface RichMenuActionsCollapseProps {
	richMenuIndex: number;
	richMenu: RichMenuData;
	updateRichMenu: (
		index: number,
		field: keyof RichMenuData,
		value: any,
	) => void;
}

export const RichMenuActionsCollapse: React.FC<RichMenuActionsCollapseProps> =
	React.memo(({ richMenuIndex, richMenu, updateRichMenu }) => {
		const areas = richMenu?.areas || [];

		if (areas.length === 0) {
			return (
				<Collapse
					items={[
						{
							key: "0",
							label: "No actions available",
							children: (
								<p style={{ color: "#999" }}>
									Select a template to configure actions
								</p>
							),
						},
					]}
				/>
			);
		}

		return (
			<Collapse
				defaultActiveKey={areas.map((_, index) => index.toString())}
				items={areas.map((area, areaIndex) => ({
					key: areaIndex.toString(),
					label: `${String.fromCharCode(65 + areaIndex)}`,
					children: (
						<Row gutter={16}>
							<Col span={6}>
								<Select
									placeholder="タイプ"
									value={area.action?.type}
									onChange={(value) => {
										const newAreas = [...areas];
										newAreas[areaIndex] = {
											...area,
											action: {
												...area.action,
												type: value,
											},
										};
										updateRichMenu(richMenuIndex, "areas", newAreas);
									}}
									options={RICHMENU_INPUT_OPTIONS}
								/>
							</Col>
							<Col span={18}>
								<Input
									placeholder={
										RICHMENU_ACTION_PLACEHOLDER[
											area.action
												?.type as keyof typeof RICHMENU_ACTION_PLACEHOLDER
										] || "内容"
									}
									value={
										area.action?.[
											RICHMENU_ACTION_VALUE_MAP[
												area.action
													?.type as keyof typeof RICHMENU_ACTION_VALUE_MAP
											] as keyof typeof area.action
										]
									}
									onChange={(e) => {
										const newAreas = [...areas];
										const valueKey =
											RICHMENU_ACTION_VALUE_MAP[
												area.action
													?.type as keyof typeof RICHMENU_ACTION_VALUE_MAP
											];
										newAreas[areaIndex] = {
											...area,
											action: {
												...area.action,
												[valueKey]: e.target.value,
											},
										};
										updateRichMenu(richMenuIndex, "areas", newAreas);
									}}
								/>
							</Col>
						</Row>
					),
				}))}
			/>
		);
	});

RichMenuActionsCollapse.displayName = "RichMenuActionsCollapse";
